import { Inputfiledsbase } from './models/inputfiledsbase';

export class ObjectDropdownQuestion extends Inputfiledsbase<string> {
  override controlType = 'objectdropdown';
}